module.exports = require("@nestjs/cache-manager");